<template>
  <div class="content">
    <div class="container-fluid">
       <div class="row">
        <b-modal
            id="modal-top-add"
            hide-footer
            title="Add Tenant"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Tenants</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddForm)"
              >
                <b-row no-gutters>
                
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.fullName"
                      @update:modelValue="
                        (newValue) => (addData.fullName = newValue)
                      "
                      :rules="{ required: true , regex:/^[a-zA-Z ]+$/}"
                      id="text-fullName"
                      name="text-fullName"
                      label="Full Name"
                      class="mb-1 mr-sm-2"
                      description="text-fullName-feedback"
                      validatorName="Full Name"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.email"
                      @update:modelValue="
                        (newValue) => (addData.email = newValue)
                      "
                      :rules="{regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                      id="text-email"
                      name="text-email"
                      label="Email"
                      class="mb-1 mr-sm-2"
                      description="text-email-feedback"
                      validatorName="Email"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.sex"
                      @update:modelValue="
                        (newValue) => (addData.sex = newValue)
                      "
                        :options="sexOptions"
                      :rules="{ required: true }"
                      id="text-sex"
                      name="text-rent-currency-options"
                      label="Sex"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-sex-feedback"
                      validatorName="Sex"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputGroup
                      inputType="text"
                      :modelValue="addData.phoneNumber"
                      @update:modelValue="
                        (newValue) => (addData.phoneNumber = newValue)
                      "
                      :rules="{ required: true, regex:/^\d{9}$/ }"
                      id="text-phoneNumber"
                      name="text-phoneNumber"
                      label="Phone Number"
                      class="mb-1 mr-sm-2"
                      description="text-phoneNumber-feedback"
                      validatorName="Phone Number"
                      prepend="+251"
                    />
                  </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                 <Vinput
                      inputType="text"
                      :modelValue="addData.address"
                      @update:modelValue="
                        (newValue) => (addData.address = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-address"
                      name="text-address"
                      label="Address"
                      class="mb-1 mr-sm-2"
                      description="text-address-feedback"
                      validatorName="Address"
                    />
                   </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary" v-b-tooltip.hover title="Submit Tenant Information">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-AddFamily"
            hide-footer
            title="Add Family"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Family</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddFamilyForm)"
              >
                <b-row no-gutters>
                
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addFamily.familyType"
                      @update:modelValue="
                        (newValue) => (addFamily.familyType = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-familyType"
                      name="text-familyType"
                      label="Family Type"
                      class="mb-1 mr-sm-2"
                      description="text-familyType-feedback"
                      validatorName="Family Type"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addFamily.fullName"
                      @update:modelValue="
                        (newValue) => (addFamily.fullName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-fullName"
                      name="text-fullName"
                      label="Full Name"
                      class="mb-1 mr-sm-2"
                      description="text-fullName-feedback"
                      validatorName="Full Name"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addFamily.sex"
                      @update:modelValue="
                        (newValue) => (addFamily.sex = newValue)
                      "
                        :options="sexOptions"
                      :rules="{ required: true }"
                      id="text-sex"
                      name="text-rent-currency-options"
                      label="Sex"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-sex-feedback"
                      validatorName="Sex"
                    />
                  </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputGroup
                      inputType="text"
                      :modelValue="addFamily.phoneNumber"
                      @update:modelValue="
                        (newValue) => (addFamily.phoneNumber = newValue)
                      "
                      :rules="{ required: true, regex:/^\d{9}$/ }"
                      id="text-phoneNumber"
                      name="text-phoneNumber"
                      label="Phone Number"
                      class="mb-1 mr-sm-2"
                      description="text-phoneNumber-feedback"
                      validatorName="Phone Number"
                      prepend="+251"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addFamily.email"
                      @update:modelValue="
                        (newValue) => (addFamily.email = newValue)
                      "
                      :rules="{regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                      id="text-email"
                      name="text-email"
                      label="Email"
                      class="mb-1 mr-sm-2"
                      description="text-email-feedback"
                      validatorName="Email"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                 <Vinput
                      inputType="text"
                      :modelValue="addFamily.address"
                      @update:modelValue="
                        (newValue) => (addFamily.address = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-address"
                      name="text-address"
                      label="Address"
                      class="mb-1 mr-sm-2"
                      description="text-address-feedback"
                      validatorName="Address"
                    />
                   </b-col>
                      <b-col class="mt-2">
                    <b-button type="submit" variant="primary" v-b-tooltip.hover title="Submit Family Information">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
       <div class="row">
        <b-modal
            id="modal-top-EditTenant"
            hide-footer
            title="Edit Tenant"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Edit Tenant</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitEditForm)"
              >
                <b-row no-gutters>
                
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedTenant.fullName"
                      @update:modelValue="
                        (newValue) => (selectedTenant.fullName = newValue)
                      "
                      :rules="{ required: true, regex:/^[a-zA-Z ]+$/}"
                      id="text-fullName"
                      name="text-fullName"
                      label="Full Name"
                      class="mb-1 mr-sm-2"
                      description="text-fullName-feedback"
                      validatorName="Full Name"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedTenant.email"
                      @update:modelValue="
                        (newValue) => (selectedTenant.email = newValue)
                      "
                      :rules="{regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                      id="text-email"
                      name="text-email"
                      label="Email"
                      class="mb-1 mr-sm-2"
                      description="text-email-feedback"
                      validatorName="Email"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedTenant.sex"
                      @update:modelValue="
                        (newValue) => (selectedTenant.sex = newValue)
                      "
                        :options="sexOptions"
                      :rules="{ required: true }"
                      id="text-sex"
                      name="text-sex-options"
                      label="Sex"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-sex-feedback"
                      validatorName="Sex"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputGroup
                      inputType="text"
                      :modelValue="selectedTenant.phoneNumber"
                      @update:modelValue="
                        (newValue) => (selectedTenant.phoneNumber = newValue)
                      "
                      :rules="{ required: true, regex:/^\d{9}$/ }"
                      id="text-phoneNumber"
                      name="text-phoneNumber"
                      label="Phone Number"
                      class="mb-1 mr-sm-2"
                      description="text-phoneNumber-feedback"
                      validatorName="Phone Number"
                      prepend="+251"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                 <Vinput
                      inputType="text"
                      :modelValue="selectedTenant.address"
                      @update:modelValue="
                        (newValue) => (selectedTenant.address = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-address"
                      name="text-address"
                      label="Address"
                      class="mb-1 mr-sm-2"
                      description="text-address-feedback"
                      validatorName="Address"
                    />
                   </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary" v-b-tooltip.hover title="Update Tenant Information">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-Details"
            hide-footer
            title="Details"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>Detail</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-row>
              <b-col md="6" v-if="selectedTenant1.ContractInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="6" style="font-weight: 700;text-align: center !important;">Contracts</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th></b-th>
                        <b-th>Tenant</b-th>
                        <b-th>Tenant Phone No</b-th>
                        <b-th>From</b-th>
                        <b-th>To</b-th>
                        <b-th>Total Payment Recieved</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(contract, index) in selectedTenant1.ContractInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="contract.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{contract.TenantFullName}}</b-td>
                        <b-td>{{contract.TenantPhoneNumber}}</b-td>
                        <b-td>{{contract.ContractStartDate}}</b-td>
                        <b-td>{{contract.ContractEndDate}}</b-td>
                        <b-td>{{contract.TotalAmountForThisContract}}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="5" style="font-weight: 700;text-align: right !important;">Total</b-td>
                        <b-td style="font-weight: 700;">{{selectedTenant1.TotalAmountForHouse}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
              <b-col md="6">
               <b-table-simple
                  :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                     <b-tr>
                        <b-th colspan="5" style="font-weight: 700;text-align: center !important;">Family Information</b-th>
                     </b-tr>
                    <b-tr>
                      <b-th style="width: 15%">Full Name</b-th>
                      <b-th style="width: 12%">Family Type</b-th>
                      <b-th style="width: 12%">Addresst</b-th>
                      <b-th style="width: 15%">Phone Number</b-th>
					   <b-th style="width: 15%">Sex</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(family, index) in selectedTenant1.familyInformation"
                      :key="index"
                    >
                      <b-td>{{family.fullName}}</b-td>
                      <b-td>{{family.familyType}}</b-td>
                      <b-td>{{family.address}}</b-td>
					  <b-td>{{family.phoneNumber}}</b-td>
					  <b-td>{{family.sex}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
             <b-row>
              <b-col md="8" v-if="selectedTenant1.paymentInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="6" style="font-weight: 700;text-align: center !important;">House Property</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 12%">Rent Payed Amount</b-th>
                        <b-th style="width: 12%">Payment For</b-th>
                        <b-th style="width: 12%">Payment Date</b-th>
                        <b-th>Transaction Ref</b-th>
						            <b-th>Payment Method</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(payment, index) in selectedTenant1.paymentInformation"
                        :key="index"
                      >
                        <b-td>{{payment.payedAmount}}</b-td>
                        <b-td>{{payment.paymentCategory}}</b-td>
                        <b-td>{{payment.paymentDate}}</b-td>
                        <b-td>{{payment.transactionRef}}</b-td>
					            	<b-td>{{payment.paymentMethod}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
        </b-modal>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
               <template slot="header">
              <b-row>
              <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.create == 1" @click="AddTenant()" class="btn-outline-primary" v-b-tooltip.hover title="Add New Tenant">
                  <b-icon class="text-center" icon="plus"></b-icon> New Tenant
                </b-button>
              </b-col>
             <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''" v-b-tooltip.hover title="Clear Filter"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <div class="table-container">
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Tenant Name</b-th>
                  <b-th>Phonenumber</b-th>
                  <b-th>Email</b-th>
                  <b-th>Address</b-th>
                  <b-th>Status</b-th>
                  <b-th>Created At</b-th>
                  <b-th>Created By</b-th>
                  <b-th>Actions</b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                <b-tbody class="text-center">
                   <b-tr >
                       <b-td colspan="9" class="text-center" style="display: table-cell">
                        <b-spinner
                        style="height: 3rem; width: 3rem;"
                          variant="warning"
                        ></b-spinner>
                       </b-td>
                    </b-tr>
                </b-tbody>
              </template>
              <template v-else>
                <b-tbody>
                  <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="9" class="text-center">Nothing found</b-td>
                        <b-td>-</b-td>
                      </b-tr>
                  </template>
                  <template v-else>
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.ID"
                    >
                        <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                        <b-td>{{item.fullName}}</b-td>
                        <b-td>{{item.phoneNumber}}</b-td>
                        <b-td>{{item.email}}</b-td>
                        <b-td>{{item.address}}</b-td>
                        <b-td>{{item.tenantStatus}}</b-td>
                        <b-td>{{item.createdDate}}</b-td>
                        <b-td>{{item.registeredBy}}</b-td>
                        <b-td>
                          <b-icon icon="eye-fill" class="btn-icon mr-2" @click="ViewDetail(item.tenantId)" v-b-tooltip.hover title="View Tenant Details"></b-icon>
                          <b-icon v-if="modulePermission.update == 1" icon="pencil-square" class="btn-icon mr-2" @click="EditTenant(item.tenantId)" v-b-tooltip.hover title="Edit Tenant"></b-icon>
                          <b-icon icon="person-plus-fill" class="btn-icon" @click="AddFamily(item.tenantId)" v-b-tooltip.hover title="Add Family Member"></b-icon>
                        </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </template>
            </b-table-simple>
            </div>
            <div class="pagination-container mt-2">
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                   <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
            </div>
           </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
  export default {
    components: {
      LTable,
      Card,
      Vinput,
      VinputNumber,
      Vselect,
      VinputGroup
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        sexOptions:[{value:"Male",text:"Male"},
        {value:"Female",text:"Female"},
        {value:"legalPerson",text:"Legal Person"}
        ],
        statusOptions:[
          {value:"Active",text:"Active"},
          {value:"Inactive",text:"Inactive"}
        ],
        items: [],
        buildingOptions: [],
        addData: {
          fullName: "",
          email: "",
          sex: "",
          phoneNumber: "",
          address: "",
          user:{
            id: sessionStorage.getItem("ID")
          },
          registeredBy:""
        },
         addFamily: {
          tenantId:null,
          familyType:"",
          fullName: "",
          email: "",
          sex:"",
          phoneNumber: "",
          address: "",
          user:{
            id: sessionStorage.getItem("ID")
          },
          registeredBy:""
        },
        filter: "",
        selectedTenant:{},
        selectedTenant1: {
            tenatId: null,
            ContractInformation: [],
            paymentInformation: [],
            familyInformation: [],
            TotalAmountForHouse: 0,
          },
        spinner: true
      }
    },
    computed: {
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.fullName.toLowerCase().indexOf(searchString) !== -1 ||  item.phoneNumber.toLowerCase().indexOf(searchString) !== -1 || item.email.toLowerCase().indexOf(searchString) !== -1 || item.address.toLowerCase().indexOf(searchString) !== -1 || item.registeredBy.toLowerCase().indexOf(searchString) !== -1 || item.createdDate.toLowerCase().indexOf(searchString) !== -1 || item.tenantStatus.toLowerCase().indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
    },
     mounted() {
      this.getModules();
      this.getTenantByOwnerID();
      this.$on("AfterComplete", () => {
        this.getTenantByOwnerID();
      });
    },
    methods: {
       getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              //this.items = response.data;
              var modulesList = response.data.modules;
              var BuildingModule = modulesList.filter(x=>x.name === "Tenant");
              if(BuildingModule !== null){
                this.modulePermission.view = BuildingModule[0].listData;
                this.modulePermission.create = BuildingModule[0].createData;
                this.modulePermission.update = BuildingModule[0].updateData;
                this.modulePermission.delete = BuildingModule[0].deleteData;
              }
          })
          .catch(error=>{
              //console.log(error);
          })
      },
      getTenantByOwnerID(){
        this.spinner = true;
          this.$store.dispatch('getTenantByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
           // console.log("getTenantByOwnerID", response.data)
            this.items = response.data.Contents;
            this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              //console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePage(event, page){
        this.spinner = true;
        this.$store.dispatch('getTenantByOwnerID', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePerPage(event){
        this.spinner = true;
        this.$store.dispatch('getTenantByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      AddTenant(){
        this.$bvModal.show('modal-top-add');
      },
      submitAddForm(){
            this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
                 title: 'Confirm',
                 size: 'sm',
                 buttonSize: 'sm',
                 okVariant: 'success',
                 cancelVariant: 'danger',
                 okTitle: 'YES',
                 cancelTitle: 'NO',
                 bodyClass: 'm-2',
                 hideHeaderClose: false,
                 centered: false
             })
             .then(value => {
                 if(value === true){
                    this.$store.dispatch('AddTenant', {
                      fullName: this.addData.fullName,
                      email: this.addData.email,
                      sex: this.addData.sex,  
                      phoneNumber: "+251"+this.addData.phoneNumber,
                      address: this.addData.address,
                      userId: sessionStorage.getItem("ID"),
                      registeredBy: parseInt(sessionStorage.getItem("userID")),
                      createdBy: parseInt(sessionStorage.getItem("userID"))
                    })
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `Tenant successfully created.`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-top-add');
                          this.clearData();
                    })
                    .catch(error=>{
                         this.$notifications.notify(
                          {
                            message: error.response.data,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'danger'
                          })
                          //console.log(error);
                    })
                 }
             })
             .catch(error=>{
                  //console.log(error)
             })
      },
      EditTenant(ID){
        var tenant= this.items.filter(item=> item.tenantId == ID)[0];
        this.selectedTenant.tenantId = tenant.tenantId;
        this.selectedTenant.fullName = tenant.fullName;
        this.selectedTenant.email = tenant.email;
        this.selectedTenant.sex = tenant.sex;
        this.selectedTenant.address = tenant.address;
        this.selectedTenant.status = tenant.tenantStatus;
        if(tenant.phoneNumber.startsWith("+251")){
          this.selectedTenant.phoneNumber = tenant.phoneNumber.slice(4,13);
        } else if(tenant.phoneNumber.startsWith("09")){
          this.selectedTenant.phoneNumber = tenant.phoneNumber.slice(1,10);
        } else {
          this.selectedTenant.phoneNumber = tenant.phoneNumber;
        }
        this.$bvModal.show('modal-top-EditTenant');
      },
      submitEditForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              this.$store.dispatch('EditTenant', {
                id: this.selectedTenant.tenantId,
                fullName: this.selectedTenant.fullName,
                email: this.selectedTenant.email,
                sex: this.selectedTenant.sex,
                address: this.selectedTenant.address,
                phoneNumber: "+251"+this.selectedTenant.phoneNumber,
                createdBy: parseInt(sessionStorage.getItem("userID"))
              })
              .then(response=>{
                  const isNoChange = response.status === 200 && typeof response.data === 'string' && response.data.includes('No changes detected');
                  this.$notifications.notify({
                    message: isNoChange ? response.data : 'Tenant information Successfully Updated.',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: isNoChange ? 'warning' : 'success'
                  });
                  this.$bvModal.hide('modal-top-EditTenant');
                  this.clearData();
              })
              .catch(error=>{
                this.$notifications.notify({
                  message: error.response ? error.response.data : 'An error occurred.',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                });
              })
            }
        })
        .catch(error=>{
            //console.log(error)
        })
      },
      AddFamily(ID){
      //console.log("some of", this.items);
      this.addFamily.tenantId = this.items.filter(item=> item.tenantId == ID)[0].tenantId
        var tenant= this.items.filter(item=> item.tenantId == ID)[0];
        //console.log("items ",this.items.filter(item=> item.tenantId == ID)[0]);
        this.$bvModal.show('modal-top-AddFamily');
      },
      submitAddFamilyForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              this.$store.dispatch('AddFamily', {
                tenants:{
                tenantId: this.addFamily.tenantId
                },
                familyType:this.addFamily.familyType,
                fullName : this.addFamily.fullName,
                email : this.addFamily.email,
                sex : this.addFamily.sex,
                address : this.addFamily.address,
                registeredBy: parseInt(sessionStorage.getItem("userID")),
                phoneNumber : "+251"+this.addFamily.phoneNumber,
                createdBy: parseInt(sessionStorage.getItem("userID"))
              })
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Tenant Family information Successfully Added.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-AddFamily');
                    this.clearData();
              })
              .catch(error=>{
                //console.log(error);
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  //console.log(error);
              })
            }
        })
        .catch(error=>{
            //console.log(error)
        })
      },
       ViewDetail(ID){
        this.$store.dispatch('getDetailTenant', {tenantId: ID})
        .then(response=>{
          this.selectedTenant1 = response.data;
          //console.log("some", response.data);
            this.$bvModal.show('modal-top-Details');
            this.clearData();
        })
        .catch(error=>{
          this.$notifications.notify(
              {
                message: error.response.data,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
            //console.log(error);
        })
      },
      clearData(){
        this.addData.fullName = this.addData.email = this.addData.phoneNumber = this.addData.address = this.addData.sex = "";
        this.addFamily.familyType = this.addFamily.fullName = this.addFamily.email = this.addFamily.phoneNumber = this.addFamily.address = this.addFamily.sex = "";
        this.$emit('AfterComplete');
      }
    }
  }
</script>
<style lang="scss" scoped>
.table-container {
  overflow-x: auto;
}
.pagination-container {
  border-top: 1px solid #dee2e6;
  padding-top: 8px;
  background: #fff;
  position: relative;
  z-index: 1;
}
.b-table-sticky-column:last-child {
    right: 0;
  }
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
  }
.btn-icon {
  font-size: 24px;
  cursor: pointer;
  color: rgb(37, 91, 48);
}
.btn-icon:hover {
  color: rgba(240, 206, 13, 0.937);
}
</style>